import { Modal } from 'components/modal/Modal';
import { useCallback, useState } from 'react';
import './../ConnectionsPage.scss';

import { ItemConnectionModel } from '../items/ItemConnection';
import { MakePayment } from 'pages/account/Payees/MakePayment/MakePayment';
import ModalTransferSuccess from './ModalTransferSuccess';
import { PaymentStatus } from '../models/models';
type PropsModalAddConnection = { closeModal: () => void; selectedConnection: ItemConnectionModel, activeTabParent?:string };

export const ModalSelectConnectionAssetAccount = ({
    closeModal,
    selectedConnection,
    activeTabParent
}: PropsModalAddConnection) => {
    const [txStatus, setTxStatus] = useState<PaymentStatus| undefined>();
    const closeHandler = useCallback((paymentStatus?: PaymentStatus) => {
        if(paymentStatus?.amount)
            setTxStatus(paymentStatus)
    }, []);
    return (
        <Modal
            className="make-connection-payment-modal"
            title="Make Payment To Connection"
            onCloseModal={closeModal}
            closeOnClickOutside={false}
        >
            {txStatus ? (
                <ModalTransferSuccess txDetail={txStatus} closeModal={closeModal} />
            ) : (
                <MakePayment goBack={closeHandler} connectionPayee={selectedConnection} activeTabParent={activeTabParent} />
            )}
        </Modal>
    );
};
